const SUPPORT_MEDIA_BASE = '/media/support'

export const SUPPORT_ART = {
  schedule: `${SUPPORT_MEDIA_BASE}/schedule-demo.png`,
  knowledge: `${SUPPORT_MEDIA_BASE}/knowledge-base.png`,
  contact: `${SUPPORT_MEDIA_BASE}/email-support.png`,
  whatsapp: `${SUPPORT_MEDIA_BASE}/whatsapp-support.png`,
  roadmap: `${SUPPORT_MEDIA_BASE}/road-map.png`,
  bugs: `${SUPPORT_MEDIA_BASE}/report-bug.png`,
  feature: `${SUPPORT_MEDIA_BASE}/feature-request.png`,
} as const

export type SupportArtKey = keyof typeof SUPPORT_ART
